import { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  useToast,
} from "@chakra-ui/react";
import CardForm from "../../components/CardForm";
import { IProfile, IUpdatePassword } from "./interface";
import {
  useUpdatePasswordMutation,
  useUpdateProfileMutation,
} from "../../generated/graphql";
import { useAppSelector } from "../../redux/store";
import CardFormTitle from "../../components/CardForm/CardFormTitle";

const Me = () => {
  const { me } = useAppSelector((state) => state.auth);

  const toast = useToast();

  const {
    register: registerProfile,
    handleSubmit: handleSubmitProfile,
    formState: { errors: errorsProfile },
    setValue: setValueProfile,
  } = useForm<IProfile>();

  useEffect(() => {
    if (me) {
      setValueProfile("name", me.name);
    }
  }, [me, setValueProfile]);

  const {
    register: registerPassword,
    handleSubmit: handleSubmitPassword,
    formState: { errors: errorsPassword },
    watch: watchPassword,
    reset: resetPassword,
  } = useForm<IUpdatePassword>();

  const [updateProfile, { loading: loadingProfile }] =
    useUpdateProfileMutation();

  const onChangeProfile = async (formData: IProfile) => {
    const { name } = formData;

    await updateProfile({
      variables: {
        input: {
          name,
        },
      },
    });

    toast({
      description: "Update Profile Successfully!",
      status: "success",
    });
  };

  const [updatePassword, { loading: loadingPassword }] =
    useUpdatePasswordMutation();

  const onChangePassword = async (formData: IUpdatePassword) => {
    const { newPassword, oldPassword } = formData;

    try {
      await updatePassword({
        variables: {
          input: {
            password: newPassword,
            oldPassword: oldPassword,
          },
        },
      });

      toast({
        description: "Update Password Successfully!",
        status: "success",
      });

      resetPassword();
    } catch (err: any) {
      toast({
        description:
          err.message === "password_incorrect"
            ? "The Old Password is Wrong!"
            : "Error",
        status: "error",
      });
    }
  };

  return (
    <Box maxW="50%" mx="auto">
      <CardForm>
        <CardFormTitle mb={10}>Akun</CardFormTitle>
        <form
          onSubmit={handleSubmitProfile(onChangeProfile)}
          autoComplete="off"
        >
          <FormControl isInvalid={errorsProfile.hasOwnProperty("name")}>
            <FormLabel>Your Name</FormLabel>
            <Input
              id="name"
              placeholder="Enter your name"
              {...registerProfile("name", { required: true })}
            />
            <FormErrorMessage>
              {errorsProfile.name && "Name is required!"}
            </FormErrorMessage>
          </FormControl>

          <FormControl>
            <Button
              isDisabled={loadingProfile}
              isLoading={loadingProfile}
              type="submit"
            >
              Save
            </Button>
          </FormControl>
        </form>
      </CardForm>

      <CardForm mt="3rem">
        <CardFormTitle mb={10}>Change Password</CardFormTitle>
        <form
          onSubmit={handleSubmitPassword(onChangePassword)}
          autoComplete="off"
        >
          <FormControl isInvalid={errorsPassword.hasOwnProperty("newPassword")}>
            <FormLabel>New Password</FormLabel>
            <Input
              type="password"
              placeholder="Enter new password"
              {...registerPassword("newPassword", {
                required: true,
                minLength: 6,
              })}
            />
            <FormErrorMessage>
              {errorsPassword.newPassword &&
                errorsPassword?.newPassword.type === "minLength" &&
                "Password should has 6 chars minimum!"}

              {errorsPassword.newPassword &&
                errorsPassword.newPassword.type === "required" &&
                "New Password cannot be empty"}
            </FormErrorMessage>
          </FormControl>

          <FormControl
            isInvalid={errorsPassword.hasOwnProperty("confirmNewPassword")}
          >
            <FormLabel>Confirm New Password</FormLabel>
            <Input
              type="password"
              placeholder="Confirm new password"
              {...registerPassword("confirmNewPassword", {
                required: true,
                minLength: 6,
                validate: (value) => value === watchPassword("newPassword"),
              })}
            />
            <FormErrorMessage>
              {errorsPassword?.confirmNewPassword?.type === "required"
                ? "Confirm password is required!"
                : errorsPassword?.confirmNewPassword?.type === "minLength"
                ? "Password should has 6 chars minimum!"
                : errorsPassword?.confirmNewPassword?.type === "validate"
                ? "Password is not same!"
                : ""}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errorsPassword.hasOwnProperty("oldPassword")}>
            <FormLabel>Old Password</FormLabel>
            <Input
              type="password"
              placeholder="Enter old password"
              {...registerPassword("oldPassword", { required: true })}
            />
            <FormErrorMessage>
              {errorsPassword.oldPassword && "Old Password cannot be empty!"}
            </FormErrorMessage>
          </FormControl>

          <FormControl>
            <Button
              isDisabled={loadingPassword}
              isLoading={loadingPassword}
              type="submit"
            >
              Update Password
            </Button>
          </FormControl>
        </form>
      </CardForm>
    </Box>
  );
};

export default Me;
